module.exports = __webpack_public_path__ + "static/media/DINOT-Medium.9ce58ff6.woff2";